import type { CapabilityBinding } from '../../core/types';

export const CI_CAPABILITIES = [
  {
    key: 'base-info',
    pathPrefix: '',
    options: { nameMaxLength: 63, descriptionMaxLength: 256 },
  },
  {
    key: 'network',
    pathPrefix: 'resource.network',
    options: { showSecurityGroup: true },
  },
  {
    key: 'run-policy',
    pathPrefix: '',
    options: { fixedValue: 'Always', loadFromApi: false, labelVariant: 'restartPolicy' },
  },
  {
    key: 'image',
    pathPrefix: '',
    options: {
      imageFieldPrefix: 'basic.image',
      legacyFlatFields: true,
      showPullAuth: true,
    },
  },
  {
    key: 'system-disk-size',
    pathPrefix: '',
    options: {
      fieldSegment: 'systemDiskSize',
      pricingSegment: 'systemDiskPricing',
    },
  },
  {
    key: 'startup-command-args',
    pathPrefix: 'basic.image',
    options: { commandSegment: 'command', listSegment: 'startupArgs' },
  },
  {
    key: 'env-vars',
    pathPrefix: 'basic.image',
    options: { listSegment: 'env' },
  },
  {
    key: 'service',
    pathPrefix: 'resource',
    options: { listSegment: 'services', requireAtLeastOne: false },
  },
  {
    key: 'compute',
    pathPrefix: 'resource',
    options: {
      gpuVariant: 'container',
      showBandwidth: true,
      showSharedMemory: true,
      showNic: true,
      nicsField: 'network.nics',
      vendorDeviceWorkloadType: 'ContainerInstance',
      resourceCodes: { cpu: 'vCPU', memory: 'Memory', gpu: 'vGPU', bandwidth: 'Bandwidth' },
      clearGpuOnArchitectureChange: false,
    },
  },
  {
    key: 'container-storage',
    pathPrefix: '',
    options: { listSegment: 'volumes' },
  },
  {
    key: 'dns',
    pathPrefix: 'resource.network',
  },
] as const satisfies readonly CapabilityBinding[];
